<template>
  <div class="login-page">
    <div class="login-card animate-in">
      <div class="login-header">
        <div class="logo-circle">
          <img src="https://cdn-icons-png.flaticon.com/512/10987/10987760.png" alt="Logo">
        </div>
        <h1>U-VOTO Business</h1>
        <p>Gestión de canales y audiencia en tiempo real</p>
      </div>

      <div class="login-form">
        <div class="input-group">
          <label>Email Corporativo</label>
          <input type="email" v-model="email" placeholder="admin@empresa.com">
        </div>
        <div class="input-group">
          <label>Contraseña</label>
          <input type="password" v-model="password" placeholder="••••••••">
        </div>
        <button @click="loginEmail" class="btn-login-main">Acceder al Panel</button>
        
        <div class="divider"><span>O CONTINÚA CON</span></div>
        
        <button @click="loginGoogle" class="btn-google-login">
          <img src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg" alt="G">
          Google Workspace
        </button>
      </div>
      <p v-if="error" class="error-msg">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import { auth } from '../firebase';
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

export default {
  data() {
    return {
      email: '',
      password: '',
      error: null
    }
  },
  methods: {
    async loginEmail() {
      try {
        await signInWithEmailAndPassword(auth, this.email, this.password);
        this.$router.push('/admin');
      } catch (err) {
        this.error = "Credenciales no autorizadas";
      }
    },
    async loginGoogle() {
      try {
        const provider = new GoogleAuthProvider();
        await signInWithPopup(auth, provider);
        this.$router.push('/admin');
      } catch (err) {
        this.error = "Error de conexión con Google";
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  height: 100vh;
  background: radial-gradient(circle at top right, #1e293b, #0f172a);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Inter', sans-serif;
}
.login-card {
  background: white;
  width: 90%;
  max-width: 420px;
  padding: 40px;
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.4);
}
.login-header { text-align: center; margin-bottom: 30px; }
.logo-circle { width: 60px; height: 60px; background: #f1f5f9; border-radius: 14px; display: flex; align-items: center; justify-content: center; margin: 0 auto 15px; }
.logo-circle img { width: 35px; }
.input-group { margin-bottom: 18px; text-align: left; }
.input-group label { display: block; font-size: 13px; font-weight: 600; margin-bottom: 6px; color: #64748b; }
.input-group input { width: 100%; padding: 12px; border-radius: 10px; border: 1px solid #e2e8f0; font-size: 15px; outline: none; transition: border 0.2s; }
.input-group input:focus { border-color: #6366f1; }
.btn-login-main { width: 100%; background: #6366f1; color: white; padding: 14px; border-radius: 10px; border: none; font-weight: 700; cursor: pointer; }
.divider { text-align: center; margin: 20px 0; border-bottom: 1px solid #e2e8f0; line-height: 0.1em; }
.divider span { background: white; padding: 0 10px; color: #94a3b8; font-size: 11px; }
.btn-google-login { width: 100%; display: flex; align-items: center; justify-content: center; gap: 10px; padding: 12px; border: 1px solid #e2e8f0; background: white; border-radius: 10px; cursor: pointer; font-weight: 600; }
.error-msg { color: #ef4444; text-align: center; margin-top: 15px; font-size: 13px; }
.animate-in { animation: fadeInUp 0.5s ease-out; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
</style>